import { useMemo } from 'react';
import { FormSection } from 'redux-form';
import PropTypes from 'prop-types';

import { zones as zonesService } from 'services/zones';
import { ZonesTabs } from '../blocks/zones-tabs';
import { PeriodicTariffication } from './periodic-tariffication';
import { Content } from './periodic.styled';

export const TarrificatorPeriodic = (props) => {
  const { selectedZone, setZone, disabled } = props;
  const zones = useMemo(() => zonesService.getZones(), []);

  const getTabs = () => {
    if (!selectedZone) {
      return null;
    }

    return zones.map((zone) => {
      return (
        <FormSection key={zone.id} name={zone.id}>
          <PeriodicTariffication color={zone.background_color} zone={zone.id} display={selectedZone === zone.id} name={zone.id} disabled={disabled} />
        </FormSection>
      );
    });
  };

  const tabsEl = getTabs();

  return (
    <Content>
      <ZonesTabs setZone={setZone} activeZone={selectedZone} />
      {tabsEl}
    </Content>
  );
};

TarrificatorPeriodic.propTypes = {
  selectedZone: PropTypes.any,
  setZone: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
